import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SidebarItemStore } from '@core/components/sidebar/components/sidebar-item/sidebar-item.store';
import { SidebarService } from '@core/components/sidebar/service/sidebar.service';

@Component({
  selector: 'app-sidebar-item-collapsed-hover-icon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FontAwesomeModule, RouterLink, RouterLinkActive],
  template: `
    <a
      routerLinkActive
      class="not-highlightable group border-greenish-500 bg-greenish-25 text-greenish-500 dark:bg-greenish-800 flex h-min w-min min-w-min cursor-pointer items-center justify-center rounded-l-lg border-t border-b border-l py-2 pr-[1.3rem] pl-2"
      (isActiveChange)="updateActiveRoute(mainPath(), $event)"
      [routerLinkActiveOptions]="{ exact: false }"
      routerLink="/{{ mainPath() }}">
      <fa-icon class="text-greenish-500 size-6" [icon]="icon()"></fa-icon>
    </a>
  `,
})
export class SidebarItemCollapsedHoverIconComponent {
  /** INJECTIONS **/
  /****/
  private readonly store = inject(SidebarItemStore);

  /****/
  private readonly service = inject(SidebarService);

  /** PROPERTIES **/
  /****/
  protected readonly icon = this.store.icon;

  /****/
  protected readonly mainPath = this.store.mainPath;

  protected updateActiveRoute(route: string, active: boolean) {
    this.service.setActiveRoute(route, active);
  }
}
